import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import PieChart from 'components/PieChart/PieChart'
import { IReportFilter } from 'views/Reports'
import { AccentArea } from 'components'

/**
 * @name ByIssuer
 * @desc Render % of Chargebacks by Issuer (Top N) chart
 * @filterValues IReportsFilter
 */
const ByIssuer = ({
    filterValues,
    topN = 5,
}: {
    filterValues: IReportFilter
    topN?: number
}): React.ReactElement => {
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ name: string; value: number }[]>([])

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByIssuer(filterValues, topN).then((data) => {
            setLoading(false)
            // Filter out the "Others" entry from the data
            const filteredData = data.filter((item: any) => item.name !== 'Others')
            setData(filteredData)
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AccentArea title={`% of Chargebacks by Issuer (Top ${topN})`}>
            <PieChart
                data={data}
                loading={loading}
                testId={`byIssuerTop${topN}`}
                // tooltipPercent
                height={350}
                pieLabelLayout={'inside'}
            />
        </AccentArea>
    )
}

export default ByIssuer
